<template>
  <div class="feedback-box content">
    <stickers :essay="essay" />

    <base-item
      :item="overAllCriteria"
      :format-title="formatTitle"
      :index="-2"
    />

    <base-item
      v-for="(item, index) in filteredItems"
      ref="items"
      :key="item.id"
      class="border-bottom"
      :active-highlight-index="activeHighlightIndex"
      :index="index"
      :item="item"
      :format-title="formatTitle"
      @updateActiveHighlightIndex="$emit('updateActiveHighlightIndex', index)"
    />
  </div>
</template>

<script>
import BaseItem from "@/components/essay/essay/v3/base_item.vue";
import generateBaseReportV3Mixin from "@/components/essay/essay/v3/mixins/base_report_v3";
import Stickers from "@/components/essay/essay/v3/stickers.vue";
import stickerMixin from "@/components/essay/essay/v3/mixins/sticker_mixin";

const colors = [
  "#FF2D55",
  "#FF9500",
  "#FF3B30",
  "#007AFF",
  "#F1B500",
  "#00C853",
  "#00C853",
];

export default {
  components: {
    BaseItem,
    Stickers,
  },

  // this.activeHighlightIndex
  // this.items
  // this.essay
  // this.isNoRanges
  // this.updateEssayTabData
  // this.deleteEssayTabData
  // this.updateEssay
  // this.selectedItem
  // this.selectItem
  mixins: [generateBaseReportV3Mixin("feedback"), stickerMixin],

  computed: {
    itemsWithColors() {
      return this.items.map((item, index) => ({
        ...item,
        color: colors[(index + 1) % colors.length],
        backgroundColor: `${colors[(index + 1) % colors.length]}1A`,
      }));
    },

    filteredItems() {
      if (this.selectedItem === "all") {
        return this.itemsWithColors;
      }

      return this.itemsWithColors.filter(
        (item) => item.id === this.selectedItem
      );
    },
    gradeInfo() {
      return this.items?.reduce(
        (acum, feedback) => {
          return {
            grade: acum.grade + Number(feedback.grade),
            maxGrade: acum.maxGrade + feedback.criteria.maxGrade,
          };
        },
        {
          grade: 0,
          maxGrade: 0,
        }
      );
    },
    overAllCriteria() {
      if (!this.gradeInfo) return {};

      return {
        id: 2,
        criteria: {
          name: "Overall Grade",
          maxGrade: parseFloat(this.gradeInfo?.maxGrade.toFixed(2)),
        },
        grade: parseFloat(this.gradeInfo.grade.toFixed(2)),
        percentage: parseFloat(
          (
            (this.gradeInfo.grade / this.gradeInfo?.maxGrade) * 100 || 0
          ).toFixed(2)
        ),
        analysis: this.essay?.summary?.feedback?.analysis,
        suggestions: this.essay?.summary?.feedback?.suggestions,
      };
    },
  },

  watch: {
    filteredItems() {
      if (this.isNoRanges) return;

      this.$nextTick(() => {
        const highlights = this.filteredItems?.reduce(
          (acc, feedback, index) => {
            if (!feedback.ranges) {
              return acc;
            }

            for (
              let rangeIndex = 0;
              rangeIndex < feedback.ranges.length;
              rangeIndex++
            ) {
              acc.push({
                range: feedback.ranges[rangeIndex],
                highlightIndex: index + 1,
                showHighlightIndex: true,
                refComponent: this.$refs.items?.[index],
                color: feedback.color,
                backgroundColor: feedback.backgroundColor,
              });
            }

            return acc;
          },
          []
        );

        this.$emit("updateHighlights", highlights);
      });
    },
  },

  methods: {
    formatTitle(item) {
      if (!item.criteria) return "";

      return `${item.criteria.name}: ${parseFloat(item.grade)}/${
        item.criteria.maxGrade
      } ${this.formatPercentage(this.getPercentage(item))}`;
    },
    getPercentage(item) {
      if (!item.criteria || item.criteria.maxGrade === 0) return 0;

      return parseFloat(
        ((item.grade / item.criteria.maxGrade) * 100).toFixed(2)
      );
    },
    formatPercentage(percentage) {
      return `(${percentage}%)`;
    },
  },
};
</script>

<style lang="scss" scoped>
.feedback-box.ql-container {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border-top: none;
  padding-top: 0px;
}

.border-bottom {
  border-bottom: 1px solid #dfdfdf;
}
</style>
